import * as Family from "@/family_name"
import * as FirstMale from "@/first_name_male"
import * as FirstFemale from "@/first_name_female"

let sfam = 0;
const fams = Family.Names.map((item) => {
  const apop = sfam;
  sfam += item.pop;
  return { name: item.name, apop };
});
export function roll_family_name() {
  const n = Math.random() * sfam;
  return fams.find((item) => item.apop >= n)!;
}

export function roll_first_name(gender: "M" | "F") {
  const names = gender === "M" ? FirstMale.Names : FirstFemale.Names;
  return names[Math.floor(Math.random() * names.length)];
}